module.exports = __webpack_public_path__ + "static/img/img55.21067f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img55.png
// module id = lei5
// module chunks = 1